import React, { useState } from 'react'
import { passwordValidation } from '../../utils/userValidetion'
import { useGeneral } from '../../context/general'
import useUserSettings from '../../hooks/useUserSettings'
import PasswordInput from '../ui/PasswordInput'
import TabHeader from './TabHeader'
import TabFooterButtons from './TabFooterButtons'
import styles from '../../pages/UserSettings.module.scss'

const UserPassword = () => {
    const { setPopupAlert } = useGeneral()
    const { updateUserPassword } = useUserSettings()
    const [ currPassword , setCurrPassword ] = useState('')
    const [ newPassword , setNewPassword ] = useState('')
    const [ newPasswordValidation , setNewPasswordValidation ] = useState('')

    const updatePassword = () => {
        if(!passwordValidation(newPassword)) setPopupAlert('error', 'Password must contain a number, a big letter and a small letter and be at least 8 characters.')
        else {
            if(newPassword === newPasswordValidation) {
                updateUserPassword(currPassword, newPassword)
            }
            else {
                setPopupAlert('error', 'Password confirmation does not match.')
            }
        }
    }
    const cancelUpdatePassword = () => {
        setCurrPassword('')
        setNewPassword('')
        setNewPasswordValidation('')
    }

    const changePasswordForm = (
            <form className={`${styles['form']}`}>
                <div>Current password</div>
                <PasswordInput password={currPassword} setPassword={setCurrPassword}/>
                <div>New password</div>
                <PasswordInput password={newPassword} setPassword={setNewPassword}/>
                <div>Confirm new password</div>
                <PasswordInput password={newPasswordValidation} setPassword={setNewPasswordValidation}/>
            </form>
        )   
  
    return (
        <>
            <TabHeader header='Password' msg='Please enter your current password to change your password.'/>
            { changePasswordForm } 
            <TabFooterButtons cancelFunc={cancelUpdatePassword} saveText='Update Password' saveFunc={updatePassword}/>
        </>
    )  
}

export default UserPassword